import React, { useState } from 'react';
import { Menu, Icon } from 'semantic-ui-react';
import NewBlueprintDialog from 'NewBlueprintDialog';

const AppMenuNew = function(props) {
  const [ newVisible, setNewVisible ] = useState(false);

  return (
    <React.Fragment>
      <Menu.Item onClick={() => setNewVisible(true)}>
        <Icon name='add' /> Create blueprint
      </Menu.Item>
      <NewBlueprintDialog visible={newVisible} onClose={() => setNewVisible(false)} />
    </React.Fragment>
  );
}



export default AppMenuNew;
